export const contactsData = {
    email: 'ansariaftab9762@gmail.com',
    phone: '+91 9130443960',
    address: 'Kondhwa Pune Maharashtra',

    sheetAPI: ''
}

// https://sheetdb.io/api/v1/tt5b8x0x5sbmo